import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { RUOLO_AMMINISTRATORE } from 'src/app/consts/const';
@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  private router = inject(Router);
  private storageService = inject(StorageService);

  goToIntervento() {
    throw new Error('Method not implemented.');
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  goToLogin() {
    this.router.navigate(['/login-form']);
  }

  goToResetPassword() {
    this.router.navigate(['/utenti/cambio-password']);
  }

  doubleClickMenu(path: string) {
    this.router.navigate([path]);
  }

  goToNewMovimento() {
    this.router.navigate(['/dipendenti/nuova-consegna']);
  }

  goToProposte() {
    this.router.navigate(['/dipendenti/propostegestione']);
  }

  goToTabMovimenti() {
    this.router.navigate(['/movimenti-articoli/false']);
  }

  //consegnaGiornaliera = true Cosegna giornaliera, = false Restituzione Giornaliera, = null altro
  goToDocMovimento(progrMov: number, consegnaGiornaliera?: boolean) {
    this.router.navigate(['/doc-movimento/' + progrMov + '/' + consegnaGiornaliera]);
  }

  goToAllega(idDpi: number) {
    if (this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.router.navigate([`/tabelle/articoli/new-allegato/${idDpi}`]);
    }
  }

  goToAllegaMov(idMov: number) {
    this.router.navigate([`/new-allegato-mov/${idMov}`]);
  }

  goToArticoli() {
    if (this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.router.navigate(['/tabelle/articoli']);
    }
  }

  goToArticoliDashboard(idArticolo: number) {
    this.router.navigate([`/articoli/${idArticolo}`]);
  }

  goToArticoliNew() {
    this.router.navigate(['/articoli/new']);
  }

  goToArticoliEdt(idArticolo: number) {
    this.router.navigate([`/articoli/edt/${idArticolo}`]);
  }

  goToNuovoArticolo() {
    if (this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.router.navigate(['/tabelle/articoli']);
    }
  }

  goToGestioneTipiDpi() {
    if (this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.router.navigate(['/tabelle/tipologie-articoli']);
    }
  }

  goToLink(link: string) {
    this.router.navigate([`/${link}`]);
  }

  // MAggio 2021
  goToSchedaDipendenti() {
    this.router.navigate(['/gestione-cope-dpi']);
  }

  goToCaricoDPI() {
    this.router.navigate(['/dipendenti/nuova-consegna']);
  }
  goToNuovaConsegnaDipendente(idDipendente: number) {
    this.router.navigate(['dipendenti', 'nuova-consegna', idDipendente]);
  }
  goToNuovaConsegna() {
    this.router.navigate(['dipendenti', 'nuova-consegna']);
  }
  goToDPIDipendente() {
    this.router.navigate(['/dpi-dipendente']);
  }
  goToDaFirmare() {
    this.router.navigate(['/movimenti-articoli/false']);
  }

  goToDipendenti() {
    this.router.navigate(['/dipendenti']);
  }
  goToDipedenteDashboard(idDipendente: number) {
    this.router.navigate(['dipendenti', idDipendente]);
  }
  goToDipendentiNew() {
    this.router.navigate(['/dipendenti/new']);
  }
  goToDipendentiEdt(idArticolo: number) {
    this.router.navigate([`/dipendenti/edt/${idArticolo}`]);
  }
  goToDipendentiDetail(idDipendente: number) {
    this.router.navigate(['dipendenti', 'detail', idDipendente]);
  }
  goToDipendentiDetailTab(idDipendente: number, tab: string) {
    this.router.navigate(['dipendenti', 'detail', idDipendente, tab]);
  }
  goToDipendentiImport() {
    this.router.navigate(['/dipendenti/import']);
  }
  goToNewDipendente() {
    this.router.navigate(['/dipendenti/new']);
  }

  goToMovimentazioni() {
    this.router.navigate(['/magazzino/movimentazioni']);
  }

  /*goToNuovaMovimentazione() {
    this.router.navigate(['/magazzino/movimentazioni']);
  }
*/
  goToMovimentazioneNew() {
    this.router.navigate(['/magazzino/new-movimento']);
  }

  goToArticoliDetail(idArticolo: number) {
    if (this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.router.navigate(['/tabelle/articoli', 'detail', idArticolo]);
    }
  }

  goToArticoloDetail(idArticolo: number) {
    this.router.navigate(['/articolo', 'detail', idArticolo]);
  }

  goToConsegnaGiornaliera(){
    this.router.navigate(['/consegna-giornaliera']);
  }

  goToRestituzioneGiornaliera(){
    this.router.navigate(['/restituzione-giornaliera']);
  }

  goToDashboardGiornaliera(){
    this.router.navigate(['/dashboard-giornaliera']);
  }
}
